import { Form, Input } from "taltech-styleguide";
import {
  getSelectOptions,
  InputSelectProps,
} from "@dirootie-web/components-types";
import { InputBase } from "./InputBase";
import { useField } from "formik";
import { FC } from "react";

type AdditionalProps = {
  showLabel?: boolean;
};

type Props = Omit<InputSelectProps, "formState"> & AdditionalProps;

export const InputSelect: FC<Props> = (props) => {
  const [field, meta, helpers] = useField(props.id);
  const { id, disabled, ...rest } = props;

  const OptionsInner = () => {
    const options = getSelectOptions(props as any);
    const selected = props.selected || field.value;
    return (
      <Input
        name={id}
        as="select"
        value={selected}
        onChange={(evt) => {
          helpers.setValue(evt.target.value);
        }}
        disabled={disabled}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      >
        {options.map((x) => (
          <option key={x.value} value={x.value}>
            {x.text.toString()}
          </option>
        ))}
      </Input>
    );
  };

  const innerProps = {
    id,
    disabled,
    ...rest,
    renderAs: "select",
    component: OptionsInner,
  };

  return <InputBase {...innerProps} />;
};
